import { render, staticRenderFns } from "./ColourMatchModal.vue?vue&type=template&id=6bde39aa&"
import script from "./ColourMatchModal.vue?vue&type=script&lang=js&"
export * from "./ColourMatchModal.vue?vue&type=script&lang=js&"
import style0 from "./ColourMatchModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports